import { Box, Text } from '@chakra-ui/react';

import styles from './styles.module.css';

const Badge = ({ children, variant = 'default', size = 'md', className = '', ...props }) => {
  return (
    <Box
      className={`
        ${styles['badge__container']}
        ${styles[`badge__container--${variant}`]}
        ${styles[`badge__container--${size}`]}
        ${className}
      `}
      {...props}
    >
      <Text className={styles['badge__text']}>{children}</Text>
    </Box>
  );
};

export default Badge;
